<template>
  <Modal :id="'cmp_royalty_recoupable_edit'" @cancelled="onCancelClick">
    <template slot="header">
      {{ $t("NEW/EDIT") }}
    </template>
    <template slot="body">
      <TextField
        class="m1"
        required
        type="date"
        :id="'date'"
        v-bind="textFieldConfig"
        :value="objectToEdit.date"
        :placeholder="$t('statement_year')"
        @valuechanged="onTextFieldValueChange"
        :disabled="formDisabled"
      ></TextField>
      <TextField
        class="m1"
        required
        :id="'description'"
        v-bind="textFieldConfig"
        :value="objectToEdit.description"
        :placeholder="$t('description')"
        @valuechanged="onTextFieldValueChange"
        @validated="onValidation"
        :disabled="formDisabled"
      ></TextField>
      <Dropdown
        required
        showValidationIcons
        immediateValidation
        :options="costGroupsTV"
        class="group-input m2"
        id="cost_group_id"
        :placeholder="$t('cost_group')"
        :selected="
          costGroupsTV.find((e) => e.value == objectToEdit.cost_group_id)
        "
        v-on:selectedChange="(e) => onDropdownChange('cost_group_id', e)"
        box
        :listHeight="250"
        :disabled="formDisabled"
      ></Dropdown>
      <Dropdown
        required
        showValidationIcons
        immediateValidation
        :options="currencyTV"
        class="group-input m2"
        id="currency"
        :placeholder="$t('currency')"
        :selected="currencyTV.find((e) => e.value == objectToEdit.currency)"
        v-on:selectedChange="(e) => onDropdownChange('currency', e)"
        box
        :listHeight="250"
        :disabled="formDisabled"
      ></Dropdown>
      <TextField
        class="m1"
        :id="'amount_orig_curr'"
        v-bind="textFieldConfig2"
        :value="objectToEdit.amount_orig_curr"
        :placeholder="$t('amount_original_currency')"
        @valuechanged="onTextFieldValueChange"
        @validated="onValidation"
        :disabled="formDisabled"
      ></TextField>
      <TextField
        class="m1"
        :id="'exchange_rate'"
        v-bind="textFieldConfig2"
        :value="objectToEdit.exchange_rate"
        :placeholder="$t('exchange_rate')"
        @valuechanged="onTextFieldValueChange"
        @validated="onValidation"
        :disabled="formDisabled"
      ></TextField>
      <TextField
        class="m1"
        :id="'amount'"
        v-bind="textFieldConfig2"
        :value="objectToEdit.amount"
        :placeholder="$t('amount_eur')"
        @valuechanged="onTextFieldValueChange"
        @validated="onValidation"
        :disabled="formDisabled"
      ></TextField>
      <TextField
        class="m1"
        :id="'company'"
        v-bind="textFieldConfig2"
        :value="objectToEdit.company"
        :placeholder="$t('company')"
        @valuechanged="onTextFieldValueChange"
        @validated="onValidation"
      ></TextField>
      <TextField
        class="m1"
        :id="'document_ref'"
        v-bind="textFieldConfig2"
        :value="objectToEdit.document_ref"
        :placeholder="$t('document_ref')"
        @valuechanged="onTextFieldValueChange"
        @validated="onValidation"
      ></TextField>

      <TextField
        class="m1"
        required
        type="date"
        :id="'payment_date'"
        v-bind="textFieldConfig2"
        :value="objectToEdit.payment_date"
        :placeholder="$t('payment_date')"
        @valuechanged="onTextFieldValueChange"
      ></TextField>
    </template>
    <template slot="options">
      <button
        class="dt-button s7 v1"
        @click="onOKClicked"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
      >
        {{$t('ok')}}
      </button>
      <button class="dt-button s7" @click="onCancelClick">{{$t('cancel')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";

import { Subject } from "rxjs";

import InputField from "@plugins/text-field/input-field";

import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";

import ModalContainer from "@dtplugins/modal/modal-container";

import {
  createModalMixin,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";

import { createTV, tv } from "../../../../models/text-value.model";

import { MHTTPCL } from "../../../../services/http/http-client";
import { recoupableService } from "../../../../modules/royalty/services/recoupable-service";

export default {
  components: {
    Modal,

    InputField,
    ModalContainer,

    //AdvanceSearch,
  },
  mounted: async function () {
    const resData = await recoupableService.getCost(
      this.$route.query.cost_split_id
    );

    console.log("resData", resData);
    this.costGroupList = resData.data.cost_groups;
    this.currencyList = resData.data.currencies;
    this.objectToEdit = resData.data.cs;
    this.balances = resData.data.balances;
  },
  data: function () {
    return {
      objectToEdit: {
        description: "",
        cost_group_id: null,
        currency: null,
        amount_orig_curr: "",
        exchange_rate: "",
        amount: "",
        company: "",
        document_ref: "",
        payment_date: "",
        date: "",
      },
      balances: [],
      costGroupList: [],
      currencyList: [],
      validationResult: {},

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },

      textFieldConfig2: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },
    };
  },
  mixins: [
    // createLDTHost(LDTConfig),
    //createModalMixin("advanceSearch"),
    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
  ],

  computed: {
    list: function () {
      return this.royaltyAccountList;
    },
    costGroupsTV: function () {
      return createTV(this.costGroupList, "cost_group_name", "cost_group_id");
    },
    currencyTV: function () {
      return createTV(this.currencyList, "currency_iso", "currency_iso");
    },

    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },

    formDisabled() {
      return this.balances?.length > 0;
    },
  },
  methods: {
    closeModal: function () {
      closeModalRoute(this);
    },

    onOKClicked: async function () {
      const payload = {
        kVal: this.objectToEdit.cost_split_id,
        name: "cost",
        value: "",
        item: this.objectToEdit,
      };
      const resData = await recoupableService.submitCost({
        ...this.objectToEdit,
      });
      this.$emit("changed", payload);
      this.onCancelClick();
    },
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },

    onDropdownChange: async function (key, value) {
      this.objectToEdit[key] = value.value;
    },

    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onTextFieldValueChange: function (name, value) {
      this.objectToEdit[name] = value;

      // this.selectedProductMedia = {
      //   ...this.selectedProductMedia,
      //   [name]: value,
      // };
    },
  },
};
</script>